var map = {
	"./cargo_3_2/schemaColors.json": [
		1004,
		4
	],
	"./cargo_3_3/schemaColors.json": [
		2425,
		425
	],
	"./cargo_core/schemaColors.json": [
		7449,
		449
	],
	"./cargo_full/schemaColors.json": [
		8071,
		71
	],
	"./cargo_full_3_1/schemaColors.json": [
		6489,
		489
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8956;
module.exports = webpackAsyncContext;